export function formatISODate(isoString: string): string {
    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

export function formatDateToLabel(dateString: string): string {
    const date = new Date(dateString);
    // Safeguard for invalid date
    if (isNaN(date.getTime())) {
        return dateString; // fallback, or return something like "Invalid date"
    }

    // e.g. "Fri, Dec 6"
    const weekday = date.toLocaleString("en-US", { weekday: "short" }); // "Fri"
    const month = date.toLocaleString("en-US", { month: "short" }); // "Dec"
    const day = date.getDate(); // 6

    return `${weekday}, ${month} ${day}`;
}